"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditorHeader = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const CopyIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CopyIcon"));
const PasteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PasteIcon"));
const PreviewIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PreviewIcon"));
const RedoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RedoIcon"));
const UndoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/UndoIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedCnp_1 = __importDefault(require("../FedController/useFedCnp"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const makeMyClasses = () => ({
    green: {
        color: lib_palette_1.default.positive.main,
        ['&:hover']: {
            color: lib_palette_1.default.secondary.main,
        },
    },
    enabled: {
        color: lib_palette_1.default.BlackCoral.main,
        ['&:hover']: {
            color: lib_palette_1.default.secondary.main,
        },
    },
    disabled: {
        opacity: 0.6,
    },
    root: {
        backgroundColor: lib_palette_1.default.White.main,
        borderBottom: `1px solid ${lib_palette_1.default.BorderGrey.main}`,
    },
});
function FormEditorHeader() {
    const { canUndo, canRedo } = (0, useFedDB_1.default)();
    const { copied } = (0, useFedCnp_1.default)();
    const { selected } = (0, useFedSelect_1.default)();
    const { mode, isScoreEnabled, id, isQuestionSet } = (0, useFedSetup_1.default)();
    const { openTo } = (0, useNav_1.default)();
    const { doUndo, doRedo, doCopyQuestion, doPasteQuestion } = (0, useFedActions_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handlePreview = (0, react_1.useCallback)(() => {
        openTo(lib_pages_1.default.OP_PREVIEW, { id });
    }, [openTo, id]);
    const isEditable = mode === 'edit';
    const handleCopy = (0, react_1.useCallback)(() => doCopyQuestion(selected), [doCopyQuestion, selected]);
    const handlePaste = (0, react_1.useCallback)(() => doPasteQuestion(selected), [doPasteQuestion, selected]);
    const handleUndo = (0, react_1.useCallback)(() => doUndo(), [doUndo]);
    const handleRedo = (0, react_1.useCallback)(() => doRedo(), [doRedo]);
    return (0, react_1.useMemo)(() => {
        let scoreBit = null;
        return (react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.root }, centered: true, shrink: true, gutter: true, padding: true, style: { minHeight: 40 } },
            !isQuestionSet && (react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('open-preview'), disabled: !isEditable, noOpacity: true, icon: react_1.default.createElement(PreviewIcon_1.default, { size: 18, className: myCss.enabled }), onClick: handlePreview })),
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('copy-question'), disabled: !isEditable, noOpacity: true, icon: react_1.default.createElement(CopyIcon_1.default, { size: 18, className: !!copied ? myCss.green : myCss.enabled }), onClick: handleCopy }),
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('paste-question'), noOpacity: true, icon: react_1.default.createElement(PasteIcon_1.default, { size: 18, className: !!copied ? myCss.green : myCss.disabled }), disabled: !isEditable || !copied, onClick: handlePaste }),
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('undo-changes'), noOpacity: true, icon: react_1.default.createElement(UndoIcon_1.default, { size: 18, className: canUndo ? myCss.enabled : myCss.disabled }), disabled: !isEditable || !canUndo, onClick: handleUndo }),
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('redo-changes'), noOpacity: true, icon: react_1.default.createElement(RedoIcon_1.default, { size: 18, className: canRedo ? myCss.enabled : myCss.disabled }), disabled: !isEditable || !canRedo, onClick: handleRedo }),
            react_1.default.createElement(Pane_1.default, { grow: true }),
            (isScoreEnabled || isQuestionSet) && scoreBit));
    }, [
        myCss,
        isQuestionSet,
        isEditable,
        handlePreview,
        copied,
        handleCopy,
        handlePaste,
        canUndo,
        handleUndo,
        canRedo,
        handleRedo,
        isScoreEnabled,
    ]);
}
exports.FormEditorHeader = FormEditorHeader;
exports.default = FormEditorHeader;
